export enum PostRelation {
  Owner = 'Owner',
  Commented = 'Commented',
  Watching = 'Watching',
  MemberOfGroup = 'MemberOfGroup',
  PublicPost = 'PublicPost',
}
